export enum StatusCodes {
  UnAuthorized = 401,
  Service_Unavailable = 503,
}

export enum ErrorCode {
  NOT_TRUSTED_AND_NOT_PHONE_VERIFIED = 'NOT_TRUSTED_AND_NOT_PHONE_VERIFIED',
}

export const CustomErrorDefaultMessage = 'Oops, something went wrong';
